import React, { useState, useContext } from "react";
import { useSelector, useDispatch } from 'react-redux';
import Carousel from 'react-bootstrap/Carousel'
import HomeMenu from '../components/HomeMenu'
import { getCDNImage } from '../globals';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { NavLink, useLocation } from 'react-router-dom';
import Session from 'react-session-api';
import { Form, Button, Card, Col, Row, Container, Badge } from "react-bootstrap";
import { faArrowRight, faAngleRight, faPaperPlane, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import ReactFlagsSelect from "react-flags-select";
import { HotelContext } from '../context/hotel';
import { Building } from '../components/Icons';
import Screen from '../components/Screen';
import { invertDate, formatDate, decodeBase64 } from "../functions";
import { T } from "react-translator-component";
import { UserContext } from "../context/user";
import { CheckInContext } from "../context/checkin";
import Reservation from "../components/Reservation";
import LangSelector from "../components/LangSelector";
import { isHostzSwissstay, isOffgrid, isOffgridMarius } from "../components/CheckIn/hotelConditions";
import { usePerson as usePersonContext } from "../context/person";
import PersonHomeStatus from "../components/PersonHomeStatus";
// import { useSessionPersistence } from '../hooks/useSessionPersistence';

const Slider = ({ height, images }) => {
    const showControls = (images?.length || 0) > 1;
    return (
        <Carousel
            style={{ height: height, backgroundColor: '#EEE' }}
            controls={showControls}
        >
            {images && images.map((img, idx) => (<Carousel.Item key={`home-slider-item-${idx}`}>
                <img className="d-block w-100"
                    src={getCDNImage(img)}
                    style={{ objectFit: 'cover' }}
                />
            </Carousel.Item>))}
        </Carousel>
    )
}

const Home = ({ navigation, route }) => {
    const { data, languages, refreshCache, placeholders, eventVersion: eventVersionHotel, lastEvent: lastEventHotel } = useContext(HotelContext);
    const { language, setLanguage, sessionId } = useContext(UserContext);
    const { data: checkIn, identify, eventVersion, lastEvent } = useContext(CheckInContext);

    const [width, setWidth] = useState(window.innerWidth);
    const [height, setHeight] = useState(window.innerHeight);
    const [languageCbx, setLanguageCbx] = useState('')
    // const { data } = useSelector(state => state.hotelReducer);
    const { theme } = data?.settings || { theme: null };
    const location = useLocation();
    const { data: person, setData: setPerson, logoutPerson } = usePersonContext();

    // const { sessionViewer } = useSessionPersistence();

    const updateDimensions = () => {
        setWidth(window.innerWidth);
        setHeight(window.innerHeight);
    }
    React.useEffect(() => {

        // Analytics.autoTrack('pageView', {
        //     enable: true,
        //     eventName: 'pageView',
        //     type: 'SPA',
        //     provider: 'AWSPinpoint',
        //     getUrl: () => {
        //         return window.location.origin + window.location.pathname;
        //     }
        // });

        window.addEventListener("resize", updateDimensions);
        return () => window.removeEventListener("resize", updateDimensions);
    }, []);

    React.useEffect(() => {
        let _code = language?.toUpperCase() || languages[0];
        if (_code === "EN-US") {
            _code = "US";
        }
        if (_code === "ES-ES") {
            _code = "ES";
        }
        setLanguageCbx(_code);

        // if (loadingLanguage) {
        //     // Parche:: porque el componente solo setea esto en localhost no se por que y es lo que usa para el seleccionado del combo
        //     const _storageLang = window.localStorage.getItem('rtc-lang');
        //     const _sessionLang = Session.get('language');
        //     console.log('_sessionLang', _sessionLang);
        //     console.log('langgg', _storageLang)
        //     if (_storageLang != language) {
        //         console.log('set localStorage', language)
        //         window.localStorage.setItem('rtc-lang', language);
        //     }
        //     if (_sessionLang != language) {
        //         console.log('set session', language)
        //         Session.set('language', language)
        //     }
        //     // --------
        //     // console.log(location.pathname)
        //     history.replace(location.pathname + '?lang=' + language);
        //     // location.reload();
        //     // window.location.reload();
        // }
    }, [language, data])

    // WORKAROUND QUE NO ANDA
    // React.useEffect(() => {
    //     // alert(ip)
    //     if (location.search && location.search.indexOf('sessionId=') !== -1) {
    //         const _sessionId = location.search.replace('?sessionId=', '');
    //         const _arr = _sessionId.split('--');
    //         const deviceId = decodeBase64(_arr[0]);
    //         const reservationCode = decodeBase64(_arr[1]);
    //         if (deviceId && checkIn?.externalId !== reservationCode) {
    //             console.log('identifing -- todo validar deviceId');
    //             identify(reservationCode);
    //         }
    //     }
    // }, [ location?.search ])
    // ------------------------

    // if (loadingLanguage) {
    //     return <div style={{ marginTop: 70, textAlign: "center" }}>
    //         <div className="loading text-muted mb-3"><div className="spinner-border" role="status"></div></div>
    //         <small className="text-muted">Changing language...</small>
    //     </div>
    // }

    if (!data) {
        return <h6>1--Loading...</h6>;
    }

    // if (theme == null) {
    //     return <div className="text-center">
    //         <FontAwesomeIcon size="3x" className="text-muted mt-4" icon={faExclamationCircle}/>
    //         <p className="general-title">{data.name}</p>
    //         <p className="general-text">Está página se encuentra en construcción.</p>
    //     </div>
    // }

    return (
        <Screen
            section="home"
            headerTranslucid={true}
            showBackButton={false}
        >
            {/* <LanguageList Theme="Dropdown" className="dropdown-language" onChange={ lang => { setLoadingLanguage(true); dispatch(changeLanguage(lang)); }} /> */}
            {/* <ReactFlagsSelect
                className="dropdown-language"
                countries={languages}
                customLabels={{ "ES": "Español", "US": "English", "DE": "Deutsch" }}
                selected={languageCbx}
                onSelect={(lang) => {
                    let _code = lang.toLowerCase();
                    if (_code == 'us') {
                        _code = 'en-US';
                    }
                    if (_code == 'es') {
                        _code = 'es-ES';
                    }
                    setLanguage(_code)
                }}
            /> */}
            <div className="dropdown-language mt-4">
                <LangSelector />
            </div>

            {/* {sessionViewer()} */}

            {data.settings && data.settings?.homeSlider && <Slider images={data.settings.homeSliderImages} />}
            {!data.settings || !data.settings.homeSlider && <Slider images={[]} />}

            {theme == 2 && <div className="scroll-down"><div className="scroll-down-arrow"></div></div>}
            {data.logo && <div className="home-logo-container" onClick={() => refreshCache()}>
                <img src={getCDNImage(data.logo)} className="home-logo" />
                {theme == 2 && <div className="home-hotel-info">
                    <h6 className="mb-0 mt-3 hotel-name">{data.name}</h6>
                    <p className="hotel-address mb-0">
                        <a
                            href={data?.location?.lat && data?.location?.lng && `https://maps.google.com/maps/dir/${data?.location?.lat},${data?.location?.lng}/@${data?.location?.lat},${data?.location?.lng}`}
                            target="_blank">
                            {data.address}

                        </a>
                    </p>
                </div>}
            </div>}
            {data.settings?.homeShowInfo && <div className="home-hotel-info">
                {/* <h2 className="home-name">{data.name}</h2> */}
                <h6 className="mb-0 mt-2 hotel-address text-center">
                    {!isOffgrid(data.id) && (<a
                            href={data?.location?.lat && data?.location?.lng && `https://maps.google.com/maps/dir/${data?.location?.lat},${data?.location?.lng}/@${data?.location?.lat},${data?.location?.lng}`}
                            target="_blank">
                            {data.address}
                        </a>
                    )}
                    {isOffgrid(data.id) && (<>
                            {data?.address}
                        </>
                    )}
                </h6>
                <p className="hotel-email text-center"><a href={"mailto:" + data.email}>{data.email}</a></p>
            </div>}

            {(isOffgrid(data.id) && !isOffgridMarius(data.id)) && (
                <div dangerouslySetInnerHTML={{
                    __html: placeholders?.['CUSTOM-HOME-CUSTOM']?.['1']?.[language]
                }} ></div>
            )}
            {(!isOffgrid(data.id) || isOffgridMarius(data.id)) && (
                <>
                    <PersonHomeStatus person={person} />
                    {(checkIn.status === "pending" || checkIn.status === "to_validate" || checkIn.status === "observed" || checkIn.status === "accepted" || checkIn.status === "in_stay") && checkIn.reservation && <NavLink className="text-decoration-none" style={{ color: 'inherit' }} to={`/${data.code}/checkin`}>
                        <Reservation
                            showStatus={true}
                            showPrice={false}
                            showRowInfo={!isHostzSwissstay(data.id)}
                            className="mx-2 mb-3" />
                    </NavLink>}
                    <HomeMenu codeClient={data.code} type={data.settings?.homeMenuStyle} />
                </>
            )}

        </Screen>
    );
}

export default Home;